import { SIDEBAR_SAVED_TABS } from '../../lib/constants'

export default dispatch => ({
  navigateAndClear: (sidebarView, savedContentTab) => {
    dispatch({
      type: 'app/gotoSidebar',
      payload: sidebarView
    })
    dispatch({
      type: 'app/clearSidebarHistory'
    })
    let dispatchType = null
    if (savedContentTab === SIDEBAR_SAVED_TABS.Collection) {
      dispatchType = 'collections/setCollectionsLoading'
    } else if (savedContentTab === SIDEBAR_SAVED_TABS.Content) {
      dispatchType = 'features/setFeaturesLoading'
    }
    if (dispatchType) {
      dispatch({
        type: dispatchType,
        payload: true
      })
      setTimeout(() => {
        dispatch({
          type: dispatchType,
          payload: false
        })
      }, 50)
    }
    /*
      #TODO: Adding this here until we think of a
      better place to reset the selectedFeatures
      -- WD - July 08, 2020
    */
    dispatch({
      type: 'features/resetAllSelectedFeatures'
    })
    dispatch({
      type: 'historicalImagery/removeLayers',
      payload: {
        removeWatchHandle: true,
        toggleBasemap: true
      }
    })
  },

  toggleSidebar: () => {
    dispatch({
      type: 'app/toggleSidebar'
    })
  }
})
